/**
 * Applies a Shopify discount code by hitting the /discount/:code endpoint,
 * which sets a server-side cookie that Shopify reads at checkout.
 */

const SUCCESS_STATUSES = new Set([200, 204, 302])

function isSuccessResponse(response: Response): boolean {
	if (response.type === 'opaqueredirect') return true
	if (response.status === 0) return true

	return SUCCESS_STATUSES.has(response.status)
}

export async function applyDiscountCookie(
	discountCode: string | undefined | null,
	redirectPath: string = '/cart'
): Promise<boolean> {
	const trimmed = discountCode?.trim()
	if (!trimmed) return false

	const encoded = encodeURIComponent(trimmed)
	const redirect = encodeURIComponent(redirectPath || '/cart')
	const root =
		(window.Shopify as { routes?: { root?: string } } | undefined)?.routes
			?.root || '/'
	const url = `${root}discount/${encoded}?redirect=${redirect}`

	try {
		const response = await fetch(url, {
			method: 'GET',
			credentials: 'include',
			redirect: 'manual',
		})

		if (isSuccessResponse(response)) return true

		console.warn(
			'[Discount] Unexpected response applying discount cookie',
			trimmed,
			response.status,
			response.statusText
		)

		return false
	} catch (error) {
		console.error(
			'[Discount] Failed to apply discount cookie',
			trimmed,
			error
		)
		return false
	}
}
